export default {
  title: 'لیست صورتحساب',
  dateFilter: {
    selectRange: 'انتخاب بازه تاریخی',
    today: 'امروز',
    yesterday: 'دیروز',
    singleDate: 'تاریخ واحد',
    selectDate: 'انتخاب تاریخ',
    last7Days: '7 روز گذشته',
    last30Days: '30 روز گذشته',
    customRange: 'بازه سفارشی',
    all: 'همه',
    currentMonth: 'این ماه',
    startDate: 'تاریخ شروع',
    endDate: 'تاریخ پایان',
    to: 'تا'
  },
  sync: {
    title: 'همگام‌سازی',
    noSelection: 'موردی انتخاب نشده',
    selectItems: 'لطفا موارد مورد نظر برای همگام‌سازی را انتخاب کنید',
    success: 'با موفقیت با QuickBooks همگام‌سازی شد',
    completed: 'موارد انتخاب شده با موفقیت همگام‌سازی شدند',
    error: 'خطا در همگام‌سازی',
    failed: 'همگام‌سازی با QuickBooks ناموفق بود',
    pending: 'در انتظار همگام‌سازی',
    manual: 'پردازش دستی',
    resend: 'ارسال مجدد'
  },
  loadNew: {
    title: 'بارگذاری جدید',
    success: 'بارگذاری موفق',
    completed: 'موارد جدید بارگذاری شد',
    added: 'اضافه شد',
    skipped: 'رد شد',
    pending: 'مورد دیگر در انتظار (دوباره بارگذاری جدید را بزنید)',
    errors: 'خطا',
    error: 'خطا در بارگذاری',
    failed: 'بارگذاری موارد جدید ناموفق بود',
    alreadyProcessing: 'در حال پردازش',
    alreadyProcessingDesc: 'درخواست بارگذاری دیگری در حال اجرا است'
  },
  retry: {
    success: 'تلاش مجدد موفق',
    completed: 'لینک مشتری QB پیدا شد و داده‌ها به‌روز شدند',
    error: 'عدم وجود لینک QB',
    failed: 'مشتری هنوز در QuickBooks لینک نشده است. لطفاً ابتدا در بخش بررسی همگام‌سازی آن را لینک کنید.'
  },
  retryAll: {
    title: 'تلاش مجدد همه',
    success: 'تلاش مجدد همه موفق',
    completed: 'تلاش مجدد گروهی تکمیل شد',
    updated: 'به‌روز شد',
    notFound: 'پیدا نشد',
    error: 'خطا در تلاش مجدد همه',
    failed: 'تلاش مجدد موارد ناموفق بود'
  },
  types: {
    all: 'همه',
    device: 'تجهیزات',
    service: 'سرویس‌ها',
    'no-qbo': 'بدون لینک QB',
    'credits': 'اعتبارات',
    hidden: 'مخفی'
  },
  status: {
    pending: 'در انتظار',
    done: 'انجام شده',
    others: 'سایر',
    hidden: 'مخفی'
  },
  columns: {
    select: 'انتخاب همه',
    customer: 'مشتری',
    total: 'مجموع',
    price: 'قیمت',
    status: 'وضعیت',
    paymentStatus: 'وضعیت پرداخت',
    createdAt: 'تاریخ',
    details: 'جزئیات',
    location: 'موقعیت'
  },
  paymentStatus: {
    title: 'وضعیت پرداخت',
    paid: 'پرداخت شده',
    partial: 'پرداخت جزئی',
    due: 'مانده',
    unpaid: 'پرداخت نشده',
    overdue: 'معوقه',
    voided: 'باطل شده',
    free: 'رایگان',
    dueSoon: '<۱۲ ساعت',
    left: 'مانده',
    overdueTooltip: 'پرداخت معوقه است! مشتری باید فاکتور را پرداخت کند.',
    dueSoonTooltip: 'کمتر از ۱۲ ساعت تا سررسید پرداخت',
    voidedTooltip: 'فاکتور در کوئیک‌بوکس باطل شده است',
  },
  details: {
    nocApproved: {
      label: 'تأیید ناک برای تجهیزات',
      yes: 'تأیید ناک',
      no: 'در انتظار ناک',
    },
    title: 'جزئیات اعتبارسنجی',
    customerInfo: {
      title: 'اطلاعات مشتری',
      name: 'نام',
      email: 'ایمیل',
      phone: 'تلفن',
      customerType: 'نوع مشتری',
      customerId: 'شناسه مشتری',
      deltaId: 'شناسه دلتا',
      // Individual specific
      nid: 'کد ملی',
      // Business specific
      companyName: 'نام شرکت',
      licenseNo: 'شماره مجوز',
      activity: 'نوع فعالیت',
      address: 'آدرس',
      internetUsage: 'سابقه استفاده از اینترنت',
      internetPurpose: 'هدف استفاده',
      previousPackage: 'بسته قبلی',
      familiarityWithUs: 'نحوه آشنایی'
    },
    devices: {
      title: 'تجهیزات پرداخت شده',
      name: 'نام تجهیز',
      quantity: 'تعداد',
      unitPrice: 'قیمت واحد',
      total: 'جمع',
      totalPrice: 'مجموع قیمت تجهیزات'
    },
    package: {
      title: 'بسته پرداخت نشده',
      name: 'نام بسته',
      period: 'دوره سرویس',
      price: 'قیمت بسته'
    },
    total: {
      title: 'مبلغ کل',
      amount: 'مبلغ',
      readonly: 'قیمت قفل شده'
    },
    totalAmount: 'مجموع مبلغ پرداخت نشده'
  },
  actions: {
    title: 'عملیات',
    check: 'بررسی',
    approve: 'تایید',
    reject: 'رد',
    cancel: 'انصراف',
    resend: 'ارسال مجدد',
    retryQbLink: 'تلاش مجدد لینک QB',
    registerInQb: 'تکمیل ثبت در کیوبوکز',
    recheck: 'بررسی مجدد / اصلاح فاکتور',
    setManual: 'تنظیم به صورت دستی',
    unsetManual: 'لغو تنظیم دستی',
    hide: 'مخفی کردن',
    unhide: 'نمایش',
    invoiceMemo: 'یادداشت فاکتور',
    history: 'تاریخچه تغییرات',
    payment: 'صفحه پرداخت',
    refreshCredit: 'بروزرسانی کریدیت موجود',
  },
  history: {
    title: 'تاریخچه و ثبت تغییرات',
    description: 'مشاهده تغییرات اعمال شده توسط کاربران برای این رکورد.',
    originalValues: 'مقادیر اولیه',
    currentValues: 'مقادیر فعلی',
    edited: 'ویرایش شده',
    loading: 'در حال بارگذاری تاریخچه تغییرات…',
    noChanges: 'هیچ تغییری برای این مورد ثبت نشده است.',
    noChangesSub: 'تغییرات اعمال شده بر روی قیمت، تخفیف یا یادداشت در اینجا نمایش داده می‌شوند.',
    unknownUser: 'سیستم / نامشخص',
    close: 'بستن',
    fields: {
      totalPrice: 'قیمت کل',
      discount: 'تخفیف',
      memo: 'یادداشت فاکتور',
    }
  },
  memo: {
    title: 'یادداشت فاکتور',
    description: 'پیام اختیاری فاکتور QuickBooks.',
    placeholder: 'یادداشت فاکتور را بنویسید…',
    save: 'ذخیره',
    apply: 'اعمال',
    done: 'تمام',
    cancel: 'انصراف',
    close: 'بستن',
    saved: 'یادداشت فاکتور ذخیره شد',
    savedQbo: 'یادداشت فاکتور ذخیره و در QuickBooks به‌روز شد',
    error: 'ذخیره یادداشت فاکتور ناموفق بود',
  },
  dialog: {
    confirm: {
      title: 'تایید عملیات',
      approveMessage: 'آیا از تایید این مورد اطمینان دارید؟',
      rejectMessage: 'آیا از رد این مورد اطمینان دارید؟'
    }
  },
  notifications: {
    approved: {
      title: 'تایید شد',
      description: 'اعتبارسنجی با موفقیت تایید شد.'
    },
    rejected: {
      title: 'رد شد',
      description: 'اعتبارسنجی رد شد.'
    },
    error: {
      title: 'خطا',
      description: 'پردازش اعتبارسنجی با خطا مواجه شد. لطفا مجددا تلاش کنید.',
      fetchError: 'دریافت لیست با خطا مواجه شد. لطفا مجددا تلاش کنید.'
    },
    hidden: {
      title: 'مخفی',
      hideDescription: 'مورد با موفقیت مخفی شد.',
      unhideDescription: 'مورد با موفقیت نمایش داده شد.'
    },
    manual: {
      title: 'وضعیت دستی',
      description: 'وضعیت دستی با موفقیت به‌روز شد.'
    },
    saved: {
      title: 'ذخیره شد',
      description: 'قیمت تجهیزات با موفقیت به‌روزرسانی شد.'
    }
  },
  devicePricesPopover: {
    panelTitle: 'قیمت دستگاه‌ها — {count} مورد',
    device: 'دستگاه',
    qty: 'تعداد',
    catalog: 'کاتالوگ',
    unitPrice: 'قیمت واحد (افغانی)',
    subtotal: 'جمع جزء',
    total: 'جمع کل',
    discount: 'تخفیف',
    net: 'خالص',
    unknownDevice: 'دستگاه نامشخص',
    saveError: 'به‌روزرسانی قیمت دستگاه ناموفق بود'
  },
  search: {
    minChars: "لطفا حداقل ۳ کاراکتر برای جستجو وارد کنید",
    placeholder: "جستجو بر اساس نام، شناسه، قرارداد، سرویس، مرکز..."
  },
  applyCredits: {
    title: 'اعمال پیمنت روی فاکتور',
    triggerTitle: 'اعمال کردیت',
    loading: 'در حال بارگذاری اطلاعات فاکتور و کردیت...',
    selectInvoice: 'فاکتور باز برای این مشتری را انتخاب کنید',
    noOpenInvoices: 'هیچ فاکتور باز برای این مشتری یافت نشد.',
    selectCredit: 'کریدیت موجود (پیمنت) را انتخاب کنید',
    noCredits: 'هیچ کریدیت یا پیمنت باز برای این مشتری وجود ندارد.',
    creditsAvailable: 'کریدیت موجود:',
    creditsToApply: 'مبلغ اعمال',
    openAmount: 'مانده باز',
    current: 'جاری',
    overdue: 'معوقه',
    memo: 'یادداشت',
    applyButton: 'اعمال کردیت',
    cancel: 'انصراف',
    success: 'کردیت اعمال شد',
    applied: 'مبلغ {amount} با موفقیت به فاکتور اعمال شد',
    error: 'خطا',
    loadFailed: 'بارگذاری اطلاعات فاکتور و کردیت ناموفق بود',
    applyFailed: 'اعمال کردیت ناموفق بود'
  },
  refreshCredit: {
    title: 'بروزرسانی کریدیت موجود',
    success: 'کریدیت با موفقیت دریافت شد',
    error: 'خطا در دریافت کریدیت',
    failed: 'دریافت کریدیت موجود مشتری ناموفق بود',
  },
  refresh: {
    title: 'بروزرسانی کش',
    success: 'کش با موفقیت پاکسازی و داده‌ها بروزرسانی شدند',
    error: 'خطا در بروزرسانی کش'
  },
  classify: {
    title: 'طبقه‌بندی',
    dialogTitle: 'طبقه‌بندی موارد انتخاب شده',
    dialogDescription: 'یک کلاس و/یا موقعیت QuickBooks را برای طبقه‌بندی موارد انتخاب شده انتخاب کنید.',
    class: 'کلاس QuickBooks',
    location: 'موقعیت QuickBooks',
    selectClass: 'انتخاب کلاس',
    selectLocation: 'انتخاب موقعیت',
    noChange: '(بدون تغییر)',
    selectedCount: 'موارد انتخاب شده',
    noSelection: 'موردی انتخاب نشده',
    selectItems: 'لطفا حداقل یک مورد را انتخاب کنید',
    selectClassOrLocation: 'لطفا حداقل یک کلاس یا موقعیت را انتخاب کنید',
    success: 'طبقه‌بندی اعمال شد',
    updated: 'به‌روز شد',
    items: 'مورد',
    with: 'با',
    error: 'خطا در طبقه‌بندی',
    failed: 'اعمال طبقه‌بندی ناموفق بود',
    cancel: 'انصراف',
    apply: 'اعمال طبقه‌بندی'
  }
} 